module.exports = __webpack_public_path__ + "img/alisa.6c90b5a3.jpg";